import React from 'react'
import TeamMemberCard from '../utils/TeamMemberCard'
import StudentCard from '../utils/StudentCard'
import PageHero from '../utils/PageHero'
import Reveal from '../utils/Reveal'
import teamphd from '../data/teams.json'
import masters from '../data/masters.json'
import alumni from '../data/alumni.json'
import under from '../data/underGrads.json'

const groups = [
  { title: 'Ph.D. Students', people: teamphd },
  { title: 'Masters Students', people: masters },
  { title: 'Undergraduate Researchers', people: under },
  { title: 'Alumni', people: alumni },
]

const TeamsScreen = () => {
  return (
    <div>
      <PageHero
        eyebrow='People'
        title='Our Team'
      />

      <div className='container-wide page-body'>
        <section className='team-section'>
          <Reveal>
            <TeamMemberCard />
          </Reveal>
        </section>

        {groups
          .filter((g) => g.people.length > 0)
          .map((g) => (
            <section className='team-section' key={g.title}>
              <Reveal className='team-section__head'>
                <h2>{g.title}</h2>
                <span>{String(g.people.length).padStart(2, '0')}</span>
              </Reveal>
              <div className='people-grid'>
                {g.people.map((record, index) => (
                  <Reveal key={record.id} delay={(index % 4) * 0.05}>
                    <StudentCard {...record} />
                  </Reveal>
                ))}
              </div>
            </section>
          ))}
      </div>
    </div>
  )
}

export default TeamsScreen
